<template>
  <div class="content">
    <div class="container-buttons">
      <md-button
        v-if="route === 'Lista de atendimentos'"
        class="md-raised btn"
        @click="$router.push({ path: '/tickets/create' })"
      >
        Abrir Chamado
      </md-button>
    </div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ticket",
  computed: {
    route() {
      return this.$route.name;
    }
  }
};
</script>

<style scoped>
button {
  margin-left: 15px;
}
.btn {
  background-color: var(--primary-color) !important;
}
.btn:hover {
  background-color: var(--secondary-color) !important;
}
.container-buttons {
  display: flex;
  justify-content: space-between;
}
.md-icon {
  font-size: 40px !important;
  margin-right: 15px;
}
</style>
